import goLoading from "./goLoading.vue";
export default goLoading;



// WEBPACK FOOTER //
// ./goingsrc/vueCom/goLoading/index.js